import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-651b277e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "questionnaire"
}
const _hoisted_2 = {
  "data-questionnaire-view": "",
  class: "questionnaire__view"
}
const _hoisted_3 = { class: "questionnaire__container" }
const _hoisted_4 = { class: "questionnaire__header" }
const _hoisted_5 = {
  "data-feedback": "",
  class: "questionnaire__feedback questionnaire__feedback--correct",
  "data-v-1c183d63": ""
}
const _hoisted_6 = {
  "data-feedback": "",
  class: "questionnaire__feedback questionnaire__feedback--wrong",
  "data-v-1c183d63": ""
}
const _hoisted_7 = { class: "questionnaire__feedback__items" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Resposta incorreta!", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Tente outra vez. ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  "data-feedback": "",
  class: "questionnaire__feedback questionnaire__feedback--inCorrection",
  "data-v-1c183d63": ""
}
const _hoisted_14 = {
  key: 0,
  class: "questionnaire__attempts"
}
const _hoisted_15 = { class: "questionnaire__attempts-number" }
const _hoisted_16 = {
  key: 0,
  class: "questionnaire__attempt-limit"
}
const _hoisted_17 = { class: "questionnaire__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeFormatter = _resolveComponent("TimeFormatter")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_Image = _resolveComponent("Image")!
  const _component_QuestionAlternatives = _resolveComponent("QuestionAlternatives")!
  const _component_QuestionDescriptive = _resolveComponent("QuestionDescriptive")!
  const _component_QuestionnaireFooter = _resolveComponent("QuestionnaireFooter")!
  const _directive_nocopy = _resolveDirective("nocopy")!

  return (_ctx.question)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_TimeFormatter, { onTimeExpired: _ctx.onTimeExpired }, null, 8, ["onTimeExpired"]),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickExit && _ctx.onClickExit(...args))),
                class: "questionnaire__exit-button"
              }, " x ")
            ]),
            _withDirectives(_createElementVNode("span", _hoisted_5, " Parabéns, você acertou! ", 512), [
              [_vShow, _ctx.question.status.isCorrect === true]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                (
                _ctx.isAbleToRedoQuestions &&
                  _ctx.question.status.attempts < _ctx.question.attemptLimit
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _hoisted_10,
                      (_ctx.question.attemptLimit !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Restam " + _toDisplayString(_ctx.question.attemptLimit - _ctx.question.status.attempts) + " tentativas. ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.question.attemptLimit !== null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Você não possuí mais tentativas. "))
                    : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, _ctx.question.status.isCorrect === false]
            ]),
            _withDirectives(_createElementVNode("span", _hoisted_13, " Sua resposta foi enviada para correção ", 512), [
              [_vShow, 
            _ctx.question.type === _ctx.QuestionType.Descriptive && _ctx.question.status.answer
          ]
            ]),
            (_ctx.isAbleToRedoQuestions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createTextVNode(" Tentativas: " + _toDisplayString(_ctx.question.status.attempts ?? 0) + " ", 1),
                    (_ctx.question.attemptLimit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "/" + _toDisplayString(_ctx.question.attemptLimit), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("h2", _hoisted_17, " Pergunta " + _toDisplayString(_ctx.question.page) + " de " + _toDisplayString(_ctx.numberOfQuestions), 1),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_TUIViewer, {
                "model-value": _ctx.question.description
              }, null, 8, ["model-value"])
            ], 512), [
              [_directive_nocopy]
            ]),
            _createVNode(_component_Image, {
              "image-u-r-l": _ctx.question.imageURL
            }, null, 8, ["image-u-r-l"]),
            (_ctx.question.type === _ctx.QuestionType.Alternative)
              ? (_openBlock(), _createBlock(_component_QuestionAlternatives, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.question.type === _ctx.QuestionType.Descriptive)
              ? (_openBlock(), _createBlock(_component_QuestionDescriptive, { key: 2 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_QuestionnaireFooter)
      ]))
    : _createCommentVNode("", true)
}